import { CommonModule } from "@angular/common";
import { Component, OnInit, inject } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { AuthService } from "app/core/auth/service/auth.service";

@Component({
  selector: "ap-auth-callback",
  imports: [CommonModule, MatProgressSpinnerModule],
  template: "",
  standalone: true,
})
export class AuthCallbackComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);

  async ngOnInit(): Promise<void> {
    // Wait for Keycloak to be ready and check authentication
    const isAuthenticated = await firstValueFrom(
      this.authService.waitForKeycloakReady(),
    );

    if (isAuthenticated) {
      // Restore the original route
      const redirectPath = sessionStorage.getItem("auth_redirect") || "/";
      sessionStorage.removeItem("auth_redirect");
      this.router.navigateByUrl(redirectPath);
    } else {
      // Not authenticated - redirect to root to trigger login
      sessionStorage.removeItem("auth_redirect");
      this.router.navigate(["/"]);
    }
  }
}
